import { createAction, createReducer } from "@reduxjs/toolkit"
import httpClient from "./httpClient"

export const GET_RESOURCE_RESPONSE = createAction("GET_RESOURCE_RESPONSE")
export const GET_RESOURCE_RESPONSE_BY_IDENTIFIER = createAction(
  "GET_RESOURCE_RESPONSE_BY_IDENTIFIER"
)

function fetchResource() {
  return (dispatch) =>
    httpClient.get("/api/resources").then(({ data }) => {
      dispatch(GET_RESOURCE_RESPONSE(data))
    })
}
function deleteResource(resourceId) {
  return httpClient.delete(`/api/resource/${resourceId}`)
}
function checkUnUsedResource(identifier) {
  return httpClient.get(`/api/resource/verification/${identifier}`)
}
function fetchResourceByIdentifier(identifier) {
  return (dispatch) =>
    httpClient.get(`/api/resource/${identifier}`).then(({ data }) => {
      dispatch(GET_RESOURCE_RESPONSE_BY_IDENTIFIER(data))
    })
}

const initialState = {
  resources: [],
  existResource: false
}
const reducer = createReducer(initialState, {
  GET_RESOURCE_RESPONSE: (state, { payload }) => ({
    ...state,
    resources: payload
  }),
  GET_RESOURCE_RESPONSE_BY_IDENTIFIER: (state, { payload }) => ({
    ...state,
    existResource: payload
  })
})
export default {
  initialState,
  actions: {
    fetchResource,
    deleteResource,
    fetchResourceByIdentifier,
    checkUnUsedResource
  },
  reducer
}
